module.exports = __webpack_public_path__ + "static/img/img13_btn.dd900b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c38/img13_btn.png
// module id = aVgs
// module chunks = 0